// Vendors
import { BreakpointsEnum, MiscellaneousUserAgentsEnum, MiscellaneousVendorsEnum } from '@openbank/cf-ui-static-data';
// Constants
import constants from './constants/devices.constants';
// Utilities
import { getAppLocale } from '../locale/locale.utils';
const viewportWidth = () => window.innerWidth || document.documentElement?.clientWidth || document.body?.clientWidth || 0;
const createV4Uuid = () => constants.V4_ID_PATTERN.replace(constants.V4_ID_REGEX, (c) => {
    const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
});
const getDeviceLoginParams = ({ deviceUUID = createV4Uuid(), ...rest }) => ({
    deviceInformation: {
        ...rest,
        deviceUUID,
        webDeviceInfo: {
            version: navigator.userAgent,
        },
    },
    language: getAppLocale(),
});
const isSafariNativeBrowser = () => window.navigator?.vendor?.indexOf(MiscellaneousVendorsEnum.APPLE) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.APPLE_WEBKIT) > -1;
const isChromeBrowser = () => window.navigator?.vendor?.indexOf(MiscellaneousVendorsEnum.GOOGLE) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.APPLE_WEBKIT) > -1;
const isAndroidNativeBrowser = () => window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.APPLE_WEBKIT) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.ANDROID) > -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.CHROME) <= -1 &&
    window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.MOZILLA) > -1;
const isMobileDevice = () => viewportWidth() < BreakpointsEnum.MOBILE - 1;
const isTabletDevice = () => viewportWidth() >= BreakpointsEnum.MOBILE && viewportWidth() <= BreakpointsEnum.TABLET;
const isMobileBrowserDevice = () => {
    return [
        MiscellaneousUserAgentsEnum.ANDROID,
        MiscellaneousUserAgentsEnum.IPHONE,
        MiscellaneousUserAgentsEnum.IPAD,
        MiscellaneousUserAgentsEnum.MOBI,
    ].some(device => window.navigator.userAgent.indexOf(device) > -1);
};
const isAndroidDevice = () => {
    return window.navigator.userAgent.indexOf(MiscellaneousUserAgentsEnum.ANDROID) > -1;
};
const isIOSDevice = () => {
    return [MiscellaneousUserAgentsEnum.IPHONE, MiscellaneousUserAgentsEnum.IPAD].some(device => window.navigator.userAgent.indexOf(device) > -1);
};
const isDesktopDevice = () => {
    let check = false;
    (function (a) {
        if (constants.DEVICE_VALIDATOR.test(a)) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor);
    return !check;
};
export { createV4Uuid, getDeviceLoginParams, isAndroidNativeBrowser, isChromeBrowser, isMobileDevice, isSafariNativeBrowser, isTabletDevice, isDesktopDevice, isMobileBrowserDevice, isAndroidDevice, isIOSDevice, viewportWidth, };
//# sourceMappingURL=devices.utils.js.map